import React from "react";
//import { Modal,ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import './Alertfailed.css';
class Alertfailed extends React.Component {

    constructor(props){
        super(props);
        
    }
  render() {
    return <div className="">
                <div className="col-md-12"> 
                    <div className="row">
                        <div className="col-md-12 alert-pop-message"> 
                            <p>Please Signup</p>
                            <button type="button" className=" alert-btn-background alert-btn" onClick={() => this.props.alertcancel('false')} >Ok</button>
                        </div>
                    </div>
                </div>

  

    </div>
    }
}

export default Alertfailed;
